import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';
import type { TodayFeedResponse } from '@shared/types';

export function useTodayFeed() {
  return useQuery({
    queryKey: ['feed', 'today'],
    queryFn: async () => (await api.get<TodayFeedResponse>('/feed/today')).data,
  });
}
